import type { API } from 'chessboard/api/config/types';
import { Core } from 'chessboard/core/config/types';

/**
 * Create the selectLinesEnd method.
 */
export function createSelectLineEnd(context: API.Context) {
  /**
   * Select a line's last move.
   */
  return function selectLineEnd(lineId?: number): API.Response {
    const { api, game, mutateGame, respond } = context;

    const data = mutateGame(function callMethod() {
      game.selectLineEnd(lineId);
    });

    if (data) {
      data.pieces = api.getPieces();
    }

    return respond(Core.APIEvents.SelectLineEnd, data);
  };
}
